/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
import React,{ useState } from "react"

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Image ====== */
import download from '05Images/download.svg';
import preview from '05Images/preview.svg';
import Xmark from '05Images/Xmark.svg';
import { fileDownload3 } from "03CommonApiParts/use-file";

/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { useProvideData } from "03CommonApiParts/use-context";
import { LoadingProgressBar } from "./LoadingProgressBar";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------ ファイル ------*/
const SdivFileName = styled.div`//ファイル枠
	border: 1px solid #BDBDBD;
	width: 295px;
    height:24px;
	background-color: #EFEFEF;
	display: flex;
	justify-content: space-between;
    align-items:center;
	padding: 3px 5px;
    margin: 0px 5px 0 0;
    border-radius: 3px;
`;
const SlabelFileName = styled.div`//ファイル名
	width: 90%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-right: 3px;
`;
const SsvgIcon = styled.svg` //SVG用
    width:${props => props.size?props.size:'20px'};
    height:${props => props.size?props.size:'20px'};
    padding:0 3px;
`;
// const SaIconButton = styled.a`//ダウンロード、プレビュー用
//     display:flex;
//     align-items:center;
//     color: #2e94b9;
//     cursor: pointer;
//     &:active{
//         color:#BDBDBD;
//     }
// `;
const SdivIconButton = styled.div` //削除用
    display:flex;
    align-items:center;
    color: ${assets().color.gray};
    cursor: pointer;
    &:active{
        color:${assets().color.border};
    }
`;
//使い方
//1:ファイルデータ
//2:削除ボタンのファイルの時はtype='delete'を指定
//3:削除ボタンのファイルの時はonClickfileDelete

//削除ボタンの時
//<File 
//data={file}
//type='delete' //削除ボタン付きのファイル
//onClickfileDelete={()=>onClickfileDelete(index)}//削除ボタンを押した時の処理
///>

//ダウンロード・プレビューのとき
//<File data={file}/>

/* ========================== */  
/* ========== Main ========== */  
/* ========================== */  

export const File = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */    
    const { data, type, onClickfileDelete } = props;
    /* --------------------------- */
    /* --------- Instance -------- */
    /* --------------------------- */
    const apiData = useProvideData();//API取得データ

    /* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });

    /* プレビュー可能なタイプ */
    const previewType = ['image/png','image/jpeg','image/gif','image/bmp','application/pdf'];
    
    /* ファイルがプレビュー可能かチェック */
    const typeCheck = () =>{
        if(previewType.some(type => type === data.contentType)){
            return true;
        }
        return false;
    };
    // const [ fileURL, setFileURL ] = useState('');//データ格納用 fileURLはエンコードで使用予定
    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    /* 古いやり方 */
    // const base64toBlob = function(data, type) {
    //     const bytes = atob(data);
    //     let length = bytes.length;
    //     let out = new Uint8Array(length);
    
    //     // Loop and convert.
    //     while (length--) {
    //         out[length] = bytes.charCodeAt(length);
    //     }
    
    //     return new Blob([out], { type: type });
    // };
    /* URLを作成する処理 */
    const urlFile = async(data,type) =>{
        /*プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
        const apiName = 'ims-api';			//API Endpoint Name
        const apiPath = '/helpdesk/common/getdownloadurl';//API Path
        /* 検索キー */
        const fileList = [];
        fileList.push({fileId: data.fileId})
        const payload = {
            fileAttachment: fileList,
        };
        /* リクエストパラメータ */
        const apiBody = { payload: payload };
        /* API処理開始 */
        await apiData.getDataPost(apiName, apiPath, apiBody, (result) => {
            const url = result.responseData.payload.fileAttachment;

            if(result.isSuccessed){//APIリクエスト結果 = 正常

                if(type === 'download'){
                    /* S3からファイルのダウンロード */
                    url.forEach(async(item)=>{

                        await fileDownload3(item.signedUrl,item.contentType,(downloadResult)=>{
                            if(downloadResult.isSuccessed){
                                /* プログレスバー非表示 */
                                setProgress(false);
                                // /* ファイルのダウンロード開始! */
                                const name = data.fileName;
                                const url = window.URL.createObjectURL(new Blob([downloadResult.responseData.data],{ type: item.contentType }));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download',name);
                                link.click();
                        }else{
                                /* プログレスバー非表示 */
                                setProgress(false);
                                //スナックバー表示
                                setSnackbarMessage({      
                                    ...snackbarMessage,
                                    open:true,
                                    message:result,//APIによるエラー
                                    type: 1,//APIエラー時:1,それ以外:2 
                                    level:'error',//エラースナックバー
                                });
                            };
                        });

                    });
    
                }else{
                    /* プログレスバー非表示 */
                    setProgress(false);

                    /* ファイルのプレビュー */
                    window.open(result.responseData.payload.fileAttachment[0].signedUrl)
                };
            }else{//APIリクエスト結果 = 異常

                /*プログレスバー非表示 */
                setProgress(false);
            };
        });
    };

    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
    return (
        <>
        <LoadingProgressBar open={progress}/>
        {/* スナックバー */}
        <SnackBar
            content={snackbarMessage}
            set={setSnackbarMessage}/>
        {type === 'delete' ?
            /* 削除ボタンのみのファイル */
            <SdivFileName>
                <SlabelFileName className='baseText' style={{fontSize:assets().size.baseText}}>{data.name || data.fileName}</SlabelFileName>
                {/* 添付したファイルの削除ボタン */}
                <SdivIconButton onClick={onClickfileDelete}>
                    <SsvgIcon size={'15px'}>
                        <use xlinkHref={`${Xmark}#Xmark`}></use>
                    </SsvgIcon>
                </SdivIconButton>
            </SdivFileName>
        :<>
            {/* プレビューボタン、ダウンロードボタンのファイル */}
            <SdivFileName>
                <SlabelFileName className='baseText' style={{fontSize:assets().size.baseText}}>{data.fileName || data.name}</SlabelFileName>
                {/* <SlabelFileName>{data.fileData}</SlabelFileName> */}
                {/* ファイルプレビューボタン */}
                {typeCheck()?
                    <SdivIconButton style={{color:'#7F7F7F'}} onClick={()=>urlFile(data)}>
                        <SsvgIcon>
                            <use xlinkHref={`${preview}#preview`}></use>
                        </SsvgIcon>
                    </SdivIconButton>
                    :''
                }
                {/* ファイルDLボタン */}
                <SdivIconButton style={{color:'#2e94b9'}} onClick={()=>urlFile(data,'download')}>
                    <SsvgIcon>
                        <use xlinkHref={`${download}#download`}></use>
                    </SsvgIcon>
                </SdivIconButton>
            </SdivFileName>
        </>}
        </>
    );
};




